export type { ProfileProps } from './components/profile/models';
export { ExtendedGlobalHeader } from './ExtendedGlobalHeader';
export type { ExtendedGlobalHeaderProps } from './models';
